import { lazy, type ReactElement } from 'react';

export interface DataTransferRouteDefinition {
  capabilityPath: string;
  label: string;
  element: ReactElement;
}

export const FileTransferBrowser = lazy(() =>
  import('./components/FileTransferBrowser').then((module) => ({
    default: module.FileTransferBrowser,
  }))
);

export const DATA_TRANSFER_ROUTE_DEFINITIONS: readonly DataTransferRouteDefinition[] = [
  {
    capabilityPath: '/devices/:deviceId/files',
    label: 'File Transfer Browser',
    element: <FileTransferBrowser />,
  },
  {
    capabilityPath: '/remote/:deviceId/files',
    label: 'File Transfer Browser',
    element: <FileTransferBrowser />,
  },
];
